import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { map, Subscription } from 'rxjs';

@Injectable()
export class OskaruTitleStrategy extends TitleStrategy {
  title = inject(Title);
  subscription: Subscription | null = null;

  updateTitle(snapshot: RouterStateSnapshot): void {
    this.subscription?.unsubscribe();

    let customTitle = this.buildTitle(snapshot) || snapshot.root.data['title'];
    if (customTitle && customTitle.includes(':id')) {
      const id = this.getParamFromSnapshot(snapshot, 'id');
      customTitle = customTitle.replace(':id', id ?? '');
    }
    if (!customTitle) {
      this.title.setTitle(`oskaru`);
    } else {
      this.title.setTitle(`${customTitle} | oskaru`);
    }
  }

  private getParamFromSnapshot(snapshot: RouterStateSnapshot, param: string): string | null {
    let route = snapshot.root;
    while (route) {
      if (route.paramMap && route.paramMap.has(param)) {
        return route.paramMap.get(param);
      }
      route = route.firstChild!;
    }
    return null;
  }
}
